module.exports = __webpack_public_path__ + "static/img/A2E_training_Vietnam_2017.9c87a9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_training_Vietnam_2017.jpg
// module id = BDan
// module chunks = 0